import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative pt-[68px] overflow-hidden bg-background-50">
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-primary-100/70 blur-3xl pointer-events-none"></div>
      <div className="absolute top-40 -left-24 w-72 h-72 rounded-full bg-accent-100/60 blur-3xl pointer-events-none"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="wm-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium mb-5">
            <i className="ri-emotion-happy-line" aria-hidden="true"></i>
            播放问题一站式排查
          </span>

          <h1
            className="text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.2]"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            西瓜影院在线观看
            <br />
            遇到问题，这里都能解决
          </h1>

          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
            本站汇总西瓜影院在线观看时最常碰到的<strong className="text-foreground-900">看不了、卡顿、播放器不兼容、下载不会用</strong>等问题，
            把下载方式、播放器推荐和对应的解决方法集中在一起，帮你快速恢复流畅播放，随时看片。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#issues"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-eye-line" aria-hidden="true"></i>
              快速查找我的问题
            </a>
            <a
              href="#cant-watch"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 bg-background-50 text-foreground-900 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-error-warning-line" aria-hidden="true"></i>
              看不了怎么办
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="rounded-lg bg-background-100 border border-background-200 px-4 py-3">
                <dt className="text-xl md:text-2xl font-bold text-primary-700" style={{ fontFamily: "var(--font-heading)" }}>
                  {stat.value}
                </dt>
                <dd className="mt-1 text-xs text-foreground-600">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative wm-fade-up">
          <div className="w-full aspect-square max-w-[520px] mx-auto rounded-2xl overflow-hidden border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20home%20movie%20night%20scene%20with%20warm%20glowing%20projector%20light%2C%20bowl%20of%20fresh%20watermelon%20and%20popcorn%20on%20a%20wooden%20table%2C%20soft%20green%20and%20warm%20red%20accents%2C%20stylized%20artistic%20illustration%2C%20minimal%20warm%20aesthetic%2C%20clean%20background&width=1000&height=1000&seq=wm-cinema-hero&orientation=squarish"
              alt="居家观影场景，桌上有西瓜与爆米花，暖色灯光"
              className="w-full h-full object-top"
            />
          </div>

          <div className="wm-float absolute -bottom-4 left-2 md:left-0 flex items-center gap-3 rounded-lg bg-background-50 border border-background-200 px-4 py-3 max-w-[240px]">
            <span className="w-9 h-9 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
              <i className="ri-speed-up-line text-lg" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-950">卡顿自适应</p>
              <p className="text-xs text-foreground-600">先降清晰度，再排查网络</p>
            </div>
          </div>

          <div className="wm-float absolute -top-3 right-2 md:right-4 flex items-center gap-3 rounded-lg bg-background-50 border border-background-200 px-4 py-3">
            <span className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
              <i className="ri-check-double-line text-lg" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-950">三步排查法</p>
              <p className="text-xs text-foreground-600">看不了也不慌</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}